import axios from 'axios';

const pathRoot = '/api/audit';

export function sendClientAnalytics(clientAnalyticsData) {
    return axios.post(pathRoot + '/client_analytics', clientAnalyticsData);
}
